<template>
  <v-row>
    <DataTable
        class="elevation-0 w-100 gridTable"
        loading-text="Загрузка данных..."
        no-data-text="Нет данных"
        v-bind.sync="tableModel.bind"
        :page.sync="tableModel.bind.options.page"
    >

      <template v-slot:header="{ props }"></template>

      <template #bottom></template>

      <template v-slot:item="{ item }">
        <tr>
          <template v-for="(key, index) in items" :key="index">
            <td :class="'column' + (index + 1)">
              <slot name="item.is_active" v-bind="{ value: item.is_active }" v-if="key === 'is_active'"></slot>
              <span v-else>{{ getNestedValue(item, key) }}</span>
            </td>
          </template>
          <td :class="'column' + items.length + 1">
            <v-menu transition="slide-x-transition"
                    location="bottom left"
                    :open-on-hover="true"
                    :close-on-content-click="false"
            >
              <template v-slot:activator="{ props }">
                <div class="actionsGrid">
                  <v-btn
                      class="px-0 action-button-color"
                      icon="custom:editItemIcon"
                      variant="text"
                      @click="edit(item)"
                  />
                  <v-btn
                      variant="text"
                      icon="mdi-key-variant"
                      class="px-0 action-button-color"
                      size=""
                      @click="regenerate(item)"
                  />
                  <v-btn
                      v-if="!!item.is_active"
                      variant="text"
                      icon="mdi-cancel"
                      class="px-0 action-button-color"
                      @click="switchStatus(item, 'blocked')"
                  />
                  <v-btn
                      v-if="!item.is_active"
                      variant="text"
                      icon="mdi-play-circle-outline"
                      class="px-0 action-button-color"
                      @click="switchStatus(item, 'unblocked')"
                  />
                </div>
              </template>
            </v-menu>
          </td>
        </tr>
      </template>
    </DataTable>
  </v-row>
  <Pagination
    :table-model="tableModel"
    :page-sizes-list="pageSizesList"
  />
</template>

<script>
import SaveFormDlg from '@/components/apiToken/dialogs/SaveFormDlg.vue';
import Pagination from '@/components/Pagination.vue';
import DataTable from '@intec/vue-components/table/DataTable.vue'

export default {
  name: 'DataTableGrid',
  components: { SaveFormDlg, Pagination, DataTable },
  props: {
    tableModel: {
      Object,
      required: true,
    },
    items: {
      Array,
      required: true,
    },
    edit: {
      Function,
      required: true,
    },
    switchStatus: {
      Function,
      required: true
    },
    regenerate: {
      Function,
      required: true
    }
  },
  data() {
    return {
      pageSizesList: [
        { title: '15', value: 15 },
        { title: '25', value: 25 },
        { title: '50', value: 50 },
        { title: '100', value: 100 },
      ],
    }
  },
  methods: {
    reload() {
      this.tableModel.reload();
    },
    getNestedValue(obj, path) {
      return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : ''), obj);
    },
    updateModelValue(pageSize) {
      this.tableModel.bind.itemsPerPage = pageSize;
      this.tableModel.bind.options.itemsPerPage = pageSize;
      this.tableModel.bind.options.page = 1;
      this.reload();
    },
    changePage(pageSize) {
      this.tableModel.bind.options.page = pageSize;
      this.reload();
    }
  },
}
</script>

<style scoped lang="scss">
.actionsGrid {
  display: grid;
  align-items: center;
  grid-template-columns: repeat(4, 1fr);
  width: 20px;

  .v-btn {
    width:24px;
    min-width: 20px;
    margin: 0 4px;
  }
}

.action-button-color {
  color: rgb(var(--data-table-font-header-color));
}
</style>
